// extracted by mini-css-extract-plugin
module.exports = {"list":"screen_list__Anb4h","filterWrap":"screen_filterWrap__2VPhh","secondRow":"screen_secondRow__Cobfx"};